import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const ParallaxContainer = styled.div`
    position: relative;
    height: 540px;
    overflow: hidden;
`;

const ParallaxImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 120%; /* <--- always cover fully even when moving */
    object-fit: cover;
    transform: translateY(0px);
    will-change: transform;
    pointer-events: none;
    z-index: -1;
`;

const Parallax = ({ imageUrl }) => {
    const imageRef = useRef();

    useEffect(() => {
        const handleScroll = () => {
            if (!imageRef.current) return;

            const rect = imageRef.current.parentElement.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const elementTop = rect.top + window.scrollY;
            const scrollY = window.scrollY;

            const distanceScrolled = scrollY - elementTop;

            const parallaxFactor = 0.4; // can make this higher → stronger parallax
            const maxOffset = 200; // max how much to move

            const offset = Math.max(-maxOffset, Math.min(maxOffset, distanceScrolled * parallaxFactor));

            imageRef.current.style.transform = `translateY(${offset}px)`;
        };

        handleScroll(); // initial

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    return (
        <ParallaxContainer>
            <ParallaxImage ref={imageRef} src={imageUrl} alt="" />
        </ParallaxContainer>
    );
};

export default Parallax;
